import { ErrorMessage } from 'formik';

import { getNetworksByPayLink, getTokensByPayLink } from '../lib';
import { CryptoNetworkTokenSelect } from '../../../widgets/Invoices/InvoiceGenerateForm.PaymentTypeSelection';
import { Form, Select, Flex } from 'antd';
import { tokenToImageV2 } from 'shared/lib';

export const PaymentTypeCrypto = ({ payLink, formValues, onValueChange }) => {
  return (
    <div className="col-span-full">
      <CryptoNetworkTokenSelect
        allowedNetworks={getNetworksByPayLink(payLink)}
        allowedTokens={getTokensByPayLink(payLink, formValues.network)}
        network={formValues.network}
        token={formValues.token}
        onTokenChange={(t) => {
          onValueChange('token', t);
          onValueChange('ach_routing_number', '');
          onValueChange('account_number', '');
        }}
        onNetworkChange={(n, t) => {
          onValueChange('network', n);
          const firstToken = getTokensByPayLink(payLink, n)[0];
          onValueChange('token', firstToken);
        }}
      />
    </div>
  );
};

export const PaymentTypeFiat = ({ formValues, onValueChange }) => {
  return (
    <>
      <div className="col-span-6 sm:col-span-3">
        <Form.Item layout="vertical" label="Currency *">
          <Select
            size="large"
            id="token"
            name="token"
            onChange={(val) => {
              onValueChange('token', val);
              onValueChange('ach_routing_number', '');
              onValueChange('account_number', '');
            }}
            value={formValues.token}
            options={[
              {
                value: 'EUR',
                label: (
                  <Flex align="center" gap={'small'}>
                    {tokenToImageV2('EUR')} EUR
                  </Flex>
                ),
              },
              {
                value: 'USD',
                label: (
                  <Flex align="center" gap={'small'}>
                    {tokenToImageV2('USD')} USD
                  </Flex>
                ),
              },

              {
                value: 'GBP',
                label: (
                  <Flex align="center" gap={'small'}>
                    {tokenToImageV2('GBP')} GBP
                  </Flex>
                ),
              },

              {
                value: 'CHF',
                label: (
                  <Flex align="center" gap={'small'}>
                    {tokenToImageV2('CHF')} CHF
                  </Flex>
                ),
              },
            ]}
          />
        </Form.Item>

        <ErrorMessage
          name="token"
          component="div"
          className="mt-2 text-xs italic text-rose-500"
        />
      </div>

      <div className="col-span-6 sm:col-span-3">
        <Form.Item layout="vertical" label="Beneficiary Type">
          <Select
            size="large"
            id="bankAccountBeneficiaryType"
            name="bankAccountBeneficiaryType"
            onChange={(val) => {
              onValueChange('bankAccountBeneficiaryType', val);
            }}
            value={formValues.bankAccountBeneficiaryType}
            options={[
              {
                value: 'business',
                label: 'Business',
              },
              {
                value: 'individual',
                label: 'Individual',
              },
            ]}
          />
        </Form.Item>
      </div>
    </>
  );
};
